import React from "react";

export const Column = ({ children, color = "blue", size = "auto" }) => (
  <div className={`column ${color} ${size}`}>{children}</div>
);
